import React from "react";
import { Link } from "react-router-dom";
import NavigationHeader from "../../components/ui/NavigationHeader";
import { useAuth } from "../../contexts/AuthContext";

export default function Terms() {
    const { user, userProfile } = useAuth();
    const currentTier = userProfile?.subscription_tier || "free";
  
  return (
    <div className="min-h-screen min-h-[100dvh] bg-background">
      <NavigationHeader
        user={{ name: user?.email?.split("@")[0] || "Utilisateur" }}
        subscriptionTier={currentTier}
      />
      <main className="max-w-4xl mx-auto px-4 py-10">
        <div className="mb-8">
          <h1 className="text-3xl font-semibold text-foreground">Conditions d’utilisation</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Dernière mise à jour : {new Date().toLocaleDateString("fr-CA")}
          </p>
        </div>

        <div className="prose prose-neutral max-w-none dark:prose-invert">
          <p>
            Les présentes conditions d’utilisation (« <strong>Conditions</strong> ») encadrent l’accès
            et l’utilisation de la plateforme <strong>ImmoIQ</strong> (« <strong>Service</strong> »).
            En utilisant le Service, vous acceptez ces Conditions.
          </p>

          <h2>1. À propos du Service</h2>
          <p>
            ImmoIQ propose des outils d’analyse immobilière (calculs, projections, comparaisons,
            rapports et fonctionnalités assistées par IA). Les résultats sont fournis à titre
            informatif et ne constituent pas un avis professionnel.
          </p>

          <h2>2. Éligibilité et compte</h2>
          <ul>
            <li>Vous devez fournir des informations exactes lors de la création de votre compte.</li>
            <li>Vous êtes responsable de la confidentialité de vos identifiants.</li>
            <li>
              Vous acceptez de nous informer rapidement en cas d’accès non autorisé à votre compte.
            </li>
          </ul>

          <h2>3. Utilisation acceptable</h2>
          <p>Vous vous engagez à ne pas :</p>
          <ul>
            <li>utiliser le Service à des fins illégales ou frauduleuses;</li>
            <li>tenter de contourner les limites d’usage, le paywall ou la sécurité;</li>
            <li>extraire massivement des données (scraping) ou perturber le Service;</li>
            <li>téléverser ou fournir du contenu malveillant (virus, scripts, etc.).</li>
          </ul>

          <h2>4. Données fournies par l’utilisateur</h2>
          <p>
            Vous êtes responsable de l’exactitude des données saisies (revenus, dépenses, loyers,
            taux, etc.). Les résultats dépendent directement de ces entrées.
          </p>

          <h2>5. IA et limites</h2>
          <p>
            Certaines fonctionnalités utilisent l’intelligence artificielle. Malgré nos efforts, l’IA
            peut produire des erreurs, des omissions ou des interprétations incorrectes. Vous devez
            valider les informations importantes (ex. taxes, revenus, règlements, conditions de prêt).
          </p>

          <h2>6. Abonnements, paiement et facturation</h2>
          <ul>
            <li>Le Service peut inclure des plans payants (Base, Plus, Pro).</li>
            <li>La facturation et les paiements sont traités par notre fournisseur (ex. Stripe).</li>
            <li>
              Les fonctionnalités, limites et tarifs peuvent évoluer. Les changements importants
              seront communiqués de façon raisonnable.
            </li>
          </ul>

          <h2>7. Annulation</h2>
          <p>
            Vous pouvez annuler votre abonnement à tout moment (les accès payés restent généralement
            actifs jusqu’à la fin de la période de facturation). Sauf indication contraire, les frais
            déjà payés ne sont pas remboursables.
          </p>

          <h2>8. Propriété intellectuelle</h2>
          <p>
            Le Service, son interface, ses éléments visuels, son code et ses contenus sont protégés.
            Vous ne pouvez pas copier, reproduire ou redistribuer le Service sans autorisation.
          </p>

          <h2>9. Disponibilité et modifications</h2>
          <p>
            Nous pouvons modifier, suspendre ou interrompre tout ou partie du Service (ex. maintenance,
            sécurité, améliorations). Nous visons une bonne disponibilité, sans garantie d’absence
            d’interruption.
          </p>

          <h2>10. Limitation de responsabilité</h2>
          <p>
            Dans les limites permises par la loi, ImmoIQ n’est pas responsable des pertes financières,
            décisions d’investissement, occasions manquées ou dommages indirects résultant de
            l’utilisation du Service.
          </p>

          <h2>11. Résiliation</h2>
          <p>
            Nous pouvons suspendre ou résilier votre accès en cas de violation des présentes
            Conditions ou d’utilisation abusive.
          </p>

          <h2>12. Droit applicable</h2>
          <p>
            Ces Conditions sont régies par les lois applicables au Québec et au Canada, selon le cas.
          </p>

          <h2>13. Contact</h2>
          <p>
            Pour toute question : <Link className="underline" to="/contact">nous contacter</Link>.
          </p>
        </div>
      </main>
    </div>
  );
}
